import { useCallback, useEffect } from "react";

import { createError, parseGraphQLError } from "utils";

import { useQuery } from "hooks";
import createResolverFactory from "components/QueryClient/ResolverFactory";

function useGetPlansForUpdate() {
  const queryFactory = useCallback(() => {
    const query = `query upgradeablePlans {
          upgradeablePlans {
            id
            name
            featureList
            upgradeablePlanOptions {
                pricing {
                  currency
                  monthlyPrice
                }
            }
            eligibility {
              eligible
              cause
              suggestions {
                howtoTag
                message
                keywords {
                  keyword
                  url
                }
              }
            }
          }
          hub {
            practice {
              planKey
            }
          }
        }`;

    const resolver = ({ data }) => {
      return {
        plans: data.upgradeablePlans,
        currentPlanKey: data.hub.practice.planKey,
      };
    };

    return { query: query, resolver: createResolverFactory(resolver) };
  }, []);

  const { loading, data, numOfFetches, error, reloadData } =
    useQuery(queryFactory);

  useEffect(() => {
    if (error)
      console.error(
        "Failed to load list of upgradeable plans",
        createError({
          ...parseGraphQLError(error),
          name: "ChangePlanUpgradeablePlansError",
        })
      );
  }, [error]);

  return {
    ...data,
    loading: (loading || !error) && numOfFetches === 0,
    error: error
      ? error?.[0]?.message ||
        "Failed to load list of upgradeable plans. Please retry or contact support for assistance."
      : error,
    onReloadPlanData: () => {
      if (!loading) reloadData();
    },
  };
}

export default useGetPlansForUpdate;
